<div class="well-prepare-container">
    <!-- Well Header -->
    <div class="section-header">
        <div class="well-header-row">
            <div class="well-title">
                <h3>Well: {{ wellName }}</h3>
                <span class="prepare-subtitle">Preparing Well for Wellview</span>
            </div>
        </div>
    </div>

    <!-- Loading Schemas -->
    <div class="loading-schemas" *ngIf="loadingSchemas">
        <div class="spinner-small"></div>
        <p>Loading schemas for {{ wellName }}...</p>
    </div>

    <!-- Schema List Ready - Before Prepare Starts -->
    <div class="prepare-ready-section" *ngIf="!loadingSchemas && !prepareInProgress && !prepareComplete && !executeInProgress && !executeComplete && processedSchemas.length > 0">
        <div class="prepare-header">
            <div class="prepare-title">
                <span class="material-icons prepare-icon">list</span>
                <h3>Ready to Prepare and Ingest Schemas</h3>
            </div>
            <p class="prepare-subtitle">{{ processedSchemas.length }} schemas will be automatically prepared and pushed to Wellview</p>
        </div>

        <!-- Schemas List -->
        <div class="schemas-list-preview">
            <div class="schema-item" *ngFor="let schema of processedSchemas">
                <span class="material-icons checked">check_box</span>
                <span class="schema-name">{{ schema.displayName }}</span>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="prepare-actions">
            <button class="btn btn-cancel" (click)="navigateBackToList()">
                <span class="material-icons">arrow_back</span>
                Cancel
            </button>
            <button class="btn btn-proceed" (click)="startIngestFlowManual()">
                <span class="material-icons">publish</span>
                Prepare & Ingest Well
            </button>
        </div>
    </div>

    <!-- Prepare Progress Display -->
    <div class="prepare-progress-section" *ngIf="prepareInProgress && !loadingSchemas">
        <div class="prepare-header">
            <div class="prepare-title">
                <span class="material-icons prepare-icon">publish</span>
                <h3>Preparing Well for Wellview</h3>
            </div>
            <p class="prepare-subtitle">Automatically preparing all schemas. Please wait...</p>
        </div>

        <div class="prepare-stepper">
            <div 
                class="prepare-step" 
                *ngFor="let schema of processedSchemas; let i = index; let isLast = last"
                [class.pending]="getPrepareStatus(schema.displayName) === 'pending'"
                [class.in-progress]="getPrepareStatus(schema.displayName) === 'in-progress'"
                [class.completed]="getPrepareStatus(schema.displayName) === 'completed'"
                [class.error]="getPrepareStatus(schema.displayName) === 'error'">
                <div class="step-content">
                    <div class="schema-circle">
                        <span *ngIf="getPrepareStatus(schema.displayName) === 'completed'" class="material-icons">check</span>
                        <span *ngIf="getPrepareStatus(schema.displayName) === 'error'" class="material-icons">close</span>
                        <span *ngIf="getPrepareStatus(schema.displayName) === 'in-progress'" class="material-icons spinner-icon">sync</span>
                        <span *ngIf="getPrepareStatus(schema.displayName) === 'pending'">{{ i + 1 }}</span>
                    </div>
                    <div class="schema-label">{{ schema.displayName }}</div>
                </div>
                <div class="schema-connector" *ngIf="!isLast"></div>
            </div>
        </div>

        <div class="prepare-progress-bar">
            <div class="progress-bar-container">
                <div class="progress-bar-fill" [style.width.%]="prepareProgress"></div>
            </div>
            <span class="progress-text">{{ getCompletedCount(prepareSchemaStatuses) }}/{{ processedSchemas.length }} Complete</span>
        </div>
    </div>

    <!-- Execute Progress Display -->
    <div class="prepare-progress-section" *ngIf="executeInProgress && !loadingSchemas">
        <div class="prepare-header header-centered">
            <div class="prepare-title">
                <span class="material-icons prepare-icon">cloud_upload</span>
                <h3>Ingesting Well to Wellview</h3>
            </div>
            <p class="prepare-subtitle">Applying all schema changes to Wellview. Please wait...</p>
        </div>

        <!-- Per-schema 3-step stepper -->
        <div class="ingest-schema-list">
            <div class="ingest-schema-row" *ngFor="let schema of processedSchemas; let i = index">

                <!-- Step 1: Schema Name - always idle; no spinner -->
                <div class="ingest-node"
                    [class.node-pending]="getExecuteStatus(schema.displayName) === 'pending'"
                    [class.node-active]="getExecuteStatus(schema.displayName) === 'in-progress'"
                    [class.node-done]="getExecuteStatus(schema.displayName) === 'completed' || getExecuteStatus(schema.displayName) === 'error'">
                    <div class="ingest-circle">
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'completed'">check</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'error'">close</span>
                        <span *ngIf="getExecuteStatus(schema.displayName) === 'pending' || getExecuteStatus(schema.displayName) === 'in-progress'">{{ i + 1 }}</span>
                    </div>
                    <span class="ingest-node-label">{{ schema.displayName }}</span>
                </div>

                <!-- Connector 1 -->
                <div class="ingest-connector"
                    [class.connector-done]="getExecuteStatus(schema.displayName) === 'completed' || getExecuteStatus(schema.displayName) === 'error' || (getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'execute')"
                    [class.connector-active]="getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'prepare'">
                </div>

                <!-- Step 2: Prepare -->
                <div class="ingest-node"
                    [class.node-pending]="getExecuteStatus(schema.displayName) === 'pending'"
                    [class.node-active]="getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'prepare'"
                    [class.node-done]="getExecuteStatus(schema.displayName) === 'completed' || getExecuteStatus(schema.displayName) === 'error' || (getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'execute')">
                    <div class="ingest-circle">
                        <span class="material-icons spinner-icon" *ngIf="getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'prepare'">sync</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'completed' || (getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'execute')">check</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'error'">close</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'pending'">list_alt</span>
                    </div>
                    <span class="ingest-node-label">Prepare</span>
                </div>

                <!-- Connector 2 -->
                <div class="ingest-connector"
                    [class.connector-done]="getExecuteStatus(schema.displayName) === 'completed'"
                    [class.connector-active]="getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'execute'">
                </div>

                <!-- Step 3: Execute -->
                <div class="ingest-node"
                    [class.node-pending]="getExecuteStatus(schema.displayName) === 'pending' || (getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'prepare')"
                    [class.node-active]="getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'execute'"
                    [class.node-done]="getExecuteStatus(schema.displayName) === 'completed'"
                    [class.node-error]="getExecuteStatus(schema.displayName) === 'error'">
                    <div class="ingest-circle">
                        <span class="material-icons spinner-icon" *ngIf="getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'execute'">sync</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'completed'">check</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'error'">close</span>
                        <span class="material-icons" *ngIf="getExecuteStatus(schema.displayName) === 'pending' || (getExecuteStatus(schema.displayName) === 'in-progress' && executeSubStatus.get(schema.displayName) === 'prepare')">cloud_upload</span>
                    </div>
                    <span class="ingest-node-label">Execute</span>
                </div>

            </div>
        </div>
    </div>

    <div class="prepare-complete-section" *ngIf="(prepareComplete || executeComplete) && !prepareInProgress && !executeInProgress">
        <div class="prepare-header success">
            <div class="prepare-title">
                <span class="material-icons prepare-icon success">check_circle</span>
                <h3>{{ executeComplete ? 'Ingestion Complete' : 'Preparation Complete' }}</h3>
            </div>
            <p class="prepare-subtitle">{{ executeComplete ? 'All schema changes have been successfully applied to Wellview' : 'All schemas have been prepared successfully' }}</p>
        </div>

        <!-- Prepared/Executed Data for All Schemas -->
        <div class="operations-section">
            <div class="section-header">
                <span class="material-icons">list_alt</span>
                <h4>{{ executeComplete ? 'Ingestion Results' : 'Schema Details' }}</h4>
            </div>

            <ng-container *ngFor="let schema of processedSchemas; let i = index">
                <div 
                    class="operation-card"
                    *ngIf="(executeComplete ? getExecuteDataForSchema(schema.displayName) : getPrepareDataForSchema(schema.displayName))">
                    
                    <!-- Schema Header with Expand/Collapse -->
                    <div class="operation-header">
                        <div class="operation-title">
                            <span class="expand-icon" (click)="executeComplete ? toggleExecuteSchemaExpansion(schema.displayName) : togglePrepareSchemaExpansion(schema.displayName)">
                                <span class="material-icons" [class.expanded]="(executeComplete ? isExecuteSchemaExpanded(schema.displayName) : isPrepareSchemaExpanded(schema.displayName))">
                                    {{(executeComplete ? isExecuteSchemaExpanded(schema.displayName) : isPrepareSchemaExpanded(schema.displayName)) ? 'expand_more' : 'chevron_right'}}
                                </span>
                            </span>
                            <span class="operation-label">{{ schema.displayName }}</span>
                        </div>
                        <span class="record-count">{{ (executeComplete ? getExecuteOperations(schema.displayName) : getPrepareOperations(schema.displayName)).length }} operation(s)</span>
                    </div>

                    <!-- Schema Data Display (Collapsible) -->
                    <div class="operation-content" *ngIf="(executeComplete ? isExecuteSchemaExpanded(schema.displayName) : isPrepareSchemaExpanded(schema.displayName))">
                        <!-- Operations List -->
                        <div class="operation-card" *ngFor="let operation of (executeComplete ? getExecuteOperations(schema.displayName) : getPrepareOperations(schema.displayName)); let i = index">
                            <div class="operation-header">
                                <div class="operation-title">
                                    <span class="operation-badge" [class.badge-success]="executeComplete && operation.status === 'success'"
                                                                  [class.badge-error]="executeComplete && operation.status !== 'success'"
                                                                  [class.badge-put]="!executeComplete && operation.action === 'PUT'"
                                                                  [class.badge-post]="!executeComplete && operation.action === 'POST'"
                                                                  [class.badge-delete]="!executeComplete && operation.action === 'DELETE'">
                                        {{ executeComplete ? (operation.status === 'success' ? 'SUCCESS' : operation.status | uppercase) : getActionLabel(operation.action) }}
                                    </span>
                                    <span class="operation-label">{{ getOperationLabel(operation, i) }}</span>
                                </div>
                                <span class="record-id" *ngIf="!executeComplete && operation.content?.idrec" title="{{ operation.content.idrec }}">ID: {{ operation.content.idrec.substring(0, 8) }}...</span>
                                <span class="record-id" *ngIf="executeComplete">{{ getActionLabel(operation.action) }}</span>
                            </div>

                            <div class="operation-content">
                                <!-- PREPARE FORMAT: Show cards with left border (like Fields Created) -->
                                <div *ngIf="!executeComplete">
                                    <!-- If fields_to_update available with items, show those -->
                                    <div class="field-updates-section" *ngIf="operation.result?.fields_to_update && operation.result.fields_to_update.length > 0">
                                        <div class="subsection-title-group">
                                            <span class="material-icons">edit</span>
                                            <h5 class="subsection-title">{{ getFieldsSectionTitle(operation.action) }}</h5>
                                        </div>
                                        <div class="field-updates-grid">
                                            <div class="field-update-item" *ngFor="let field of operation.result.fields_to_update; let i = index">
                                                <div *ngIf="!isUnitVariantKey(field)">
                                                    <div class="field-header">
                                                        <div class="field-name">{{ getDisplayLabel(field) }}</div>
                                                        <!-- Show toggle for fields with unit conversions -->
                                                        <div class="unit-toggle-inline" *ngIf="hasUnitVariants(field, operation)">
                                                            <button 
                                                                *ngFor="let unit of getAvailableUnits(field, operation)"
                                                                class="unit-btn-inline" 
                                                                [class.active]="getSelectedUnit('prepare-' + i, field, operation) === unit"
                                                                (click)="setSelectedUnit(unit, 'prepare-' + i, field)"
                                                                [title]="'Show values in ' + getUnitDisplayLabel(unit)">
                                                                {{ getUnitDisplayLabel(unit) }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="field-value" *ngIf="getValueForOperationField(operation, field, 'prepare-' + i) !== null">
                                                        <span class="value-badge">{{ getValueForOperationField(operation, field, 'prepare-' + i) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- If fields_to_update is empty array, show message -->
                                    <div class="field-updates-section" *ngIf="operation.result?.fields_to_update && operation.result.fields_to_update.length === 0">
                                        <div class="subsection-title-group">
                                            <span class="material-icons">edit</span>
                                            <h5 class="subsection-title">{{ getFieldsSectionTitle(operation.action) }}</h5>
                                        </div>
                                        <div class="no-fields-message">
                                            <span class="text-muted">No fields to update</span>
                                        </div>
                                    </div>

                                    <!-- Fallback: Show all content fields if fields_to_update not provided -->
                                    <div class="field-updates-section" *ngIf="!operation.result?.fields_to_update">
                                        <div class="subsection-title-group">
                                            <span class="material-icons">edit</span>
                                            <h5 class="subsection-title">Fields</h5>
                                        </div>
                                        <div class="field-updates-grid">
                                            <div class="field-update-item" *ngFor="let field of getContentKeys(operation); let i = index">
                                                <div *ngIf="!isUnitVariantKey(field)">
                                                    <div class="field-header">
                                                        <div class="field-name">{{ getDisplayLabel(field) }}</div>
                                                        <!-- Show toggle for fields with unit conversions -->
                                                        <div class="unit-toggle-inline" *ngIf="hasUnitVariants(field, operation)">
                                                            <button 
                                                                *ngFor="let unit of getAvailableUnits(field, operation)"
                                                                class="unit-btn-inline" 
                                                                [class.active]="getSelectedUnit('prepare-' + i, field, operation) === unit"
                                                                (click)="setSelectedUnit(unit, 'prepare-' + i, field)"
                                                                [title]="'Show values in ' + getUnitDisplayLabel(unit)">
                                                                {{ getUnitDisplayLabel(unit) }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="field-value" *ngIf="getValueForOperationField(operation, field, 'prepare-' + i) !== null">
                                                        <span class="value-badge">{{ getValueForOperationField(operation, field, 'prepare-' + i) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- EXECUTE FORMAT: Approval flow style with badges and bullet list -->
                                <div *ngIf="executeComplete">
                                    <!-- Show fields as bullet list - check for both fields_updated and fields_created -->
                                    <div class="field-updates-section">
                                        <div class="subsection-title-group">
                                            <span class="material-icons">edit</span>
                                            <h5 class="subsection-title">{{ getFieldsSectionTitle(operation.action) }}</h5>
                                        </div>
                                        <!-- Display as bullet list if fields exist -->
                                        <div *ngIf="(operation.fields_updated && operation.fields_updated.length > 0) || (operation.fields_created && operation.fields_created.length > 0)">
                                            <ul class="fields-bullet-list">
                                                <li *ngFor="let field of (operation.fields_updated || operation.fields_created || [])">
                                                    <span *ngIf="!isUnitVariantKey(field)">{{ field }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <!-- Show 'No fields' message if both arrays are empty -->
                                        <div *ngIf="(!operation.fields_updated || operation.fields_updated.length === 0) && (!operation.fields_created || operation.fields_created.length === 0)" class="no-fields-message">
                                            <span class="text-muted">No fields to update</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Navigation Button -->
        <div class="prepare-actions">
            <!-- Back to Wells List Button - Show after prepare or execute completes -->
            <button class="btn btn-proceed" (click)="navigateBackToList()" *ngIf="prepareComplete || executeComplete">
                <span class="material-icons">arrow_back</span>
                Back to Wells List
            </button>
            
            <!-- Ingest Well Button - Show after prepare, but hide when execute starts/completes -->
            <button class="btn btn-proceed" (click)="startExecuteFlowManual()" 
                    *ngIf="prepareComplete && !executeInProgress && !executeComplete">
                <span class="material-icons">publish</span>
                Ingest Well
            </button>
        </div>

    </div>

    <!-- Snackbar Notification -->
    <div class="snackbar" 
         *ngIf="error" 
         [class.success]="notificationType === 'success'"
         [class.error]="notificationType === 'error'"
         [class.info]="notificationType === 'info'">
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'success'">check_circle</span>
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'error'">error</span>
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'info'">info</span>
        <span class="snackbar-message">{{ error }}</span>
        <button class="snackbar-close" (click)="error = ''">
            <span class="material-icons">close</span>
        </button>
    </div>
</div>